import { ValueList } from "appworks/utils/value-list";
import { slotModel } from "slotworks/model/slot-model";
import { AgsAbstractAutoplaySliderControl } from "./ags-abstract-autoplay-slider-control";

export class AgsSingleWinLimitSliderControl extends AgsAbstractAutoplaySliderControl {
    protected getModelData(): ValueList<number> {
        return slotModel.read().autoplay.singleWinLimit;
    }

    protected saveModelData(selectedValue: number) {
        const { autoplay } = slotModel.read();
        autoplay.singleWinLimit.currentValue = selectedValue;
        autoplay.singleWinLimit.lastSelectedValue = selectedValue ?? 0;
        slotModel.write({ autoplay });
    }
}
